<template>
    <div class="activity-module">
        <div class="title g-flex-center-center">
            <div class="icon-title2"></div>
            <div class="title-text">
                <p class="title-text-1">中秋月光存放站</p>
                <p class="title-text-2">分享假期，赢限定好礼！</p>
            </div>
            <div class="icon-title2 title-right"></div>
            <div class="title-bg icon-title-bg2"></div>
        </div>
        <div class="desc">
            <div class="desc-icon icon-activity-rabbit"></div>
            海上生明月，天涯共此时。又是一年中秋，七猫祝大家中秋多喜乐，事事皆如愿。欢迎书友们在话题<span class="text-mark">#中秋月光存放站#</span>下，分享你记录的中秋月色，记录你的中秋节相关活动民俗，赢取七猫专属好礼吧~
        </div>
        <p class="sub-title text">活动奖励：</p>
        <p class="text">优质内容创作者中随机选出5位赠送 <span class="text-mark"> 七猫文创周边</span>！</p>
        <p class="text">所有符合活动主题帖子作者中随机选出3位赠送 <span class="text-mark"> 七猫文创周边</span>！</p>
        <p class="sub-title text">活动时间：</p>
        <p class="text">2025年9月25日 - 10月8日</p>
        <div class="icon-activity-title"></div>
        <p class="tip">以图文帖形式在<span class="text-mark">#中秋月光存放站#</span>话题下分享你的中秋计划</p>

        <div class="type-item g-flex-start-center" @click="onShowTopic(3)">
            <div class="type-item-icon icon-activity-rabbit2"></div>
            <div>
                <p class="type-item-title"># 中秋月光存放站</p>
                <p class="type-item-tip">晒出赏月照片，记录中秋民俗</p>
            </div>
            <p class="type-item-btn button-2 g-flex-center-center">前往参与</p>
        </div>
    </div>
</template>
<script lang="ts" setup>
const emits = defineEmits(['showTopic']);
const onShowTopic = (type: number) => {
    emits('showTopic', type);
};
</script>
<style lang="scss" scoped></style>
